var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m368.4,90.3c-30.3,0-54.9,24.6-54.9,54.9s24.6,54.9 54.9,54.9c30.3,0 54.9-24.6 54.9-54.9s-24.6-54.9-54.9-54.9zm0,69.1c-7.8,0-14.2-6.3-14.2-14.2s6.3-14.2 14.2-14.2c7.8,0 14.2,6.3 14.2,14.2s-6.4,14.2-14.2,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.4,312.2l142.4,144.5 262.8-259-22.9-119.7-119.4-24.8-262.9,259h2.13163e-14zm142.4,188c-9.2,0-17.9-3.6-24.4-10.2l-151.6-153.9c-13.2-13.4-13.1-35.1 0.4-48.4l270-266c8.1-8 19.9-11.5 31-9.1l127,26.4c13.6,2.8 24,13.5 26.7,27.1l24.5,127.4c2.2,11.3-1.4,22.8-9.6,30.9l-270,266c-6.4,6.3-15,9.8-24,9.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.44994fa846f6f1056735783122e0a8a9.svg";
export { ForwardRef as ReactComponent };